import React, {useEffect, useState} from 'react';
import Tooltip from "./Tooltip";

const FacetedSearchSlider = ({group, onFacetChange, isMobile = false}) => {
    const [value, setValue] = useState(getInitialValue());

    const values = group.options
        .sort(function (a, b) {
                return parseInt(a.id) - parseInt(b.id)
            }
        );

    const [rendered, setRendered] = useState(false);

    function getInitialValue() {
        if (group.selectedOptions.length === 0) {
            return -1;
        }

        return group.options.indexOf(group.options.find(x => x.id === group.selectedOptions[0])) + 1;
    }

    useEffect(() => {
        if (rendered) {
            onFacetChange(group, values[value - 1]);
        }

        setRendered(true);

    }, [value]);

    function handleClick(index) {
        if (index + 1 === 1) {
            setValue(-1);
            return;
        }

        setValue(index + 1);
    }

    useEffect(() => {
        if(group.selectedOptions.length === 0){
            setValue(-1);

        }
    }, [group.selectedOptions]);
    
    return (
        <li className={isMobile ? "mobile-modal__filter-list-item" : ""}>
            {
                isMobile && <p className="mobile-modal__filter-title">
                    <span className="flex">
                        <span>{group.label}</span>
                        {group.description && <Tooltip inline={true} helpText={group.description}/>}
                    </span>
                </p>
            }
            <div className="faceted-filter__range-slider">
                <input className="faceted-filter__range-slider-input" type="range" min="1" max="5" value={value}
                       onChange={e => setValue(e.target.value)}/>
                <div className="faceted-filter__range-slider-button-container">
                    {group.options.map((option, index) => {
                        return <button
                            key={"range-slider-" + option.id}
                            className={"faceted-filter__range-slider-button " + (value <= index + 1 ? "faceted-filter__range-slider-button--active" : "")}
                            onClick={() => handleClick(index)}></button>
                    })}
                </div>
                <div className="faceted-filter__range-slider-text-container">
                    {group.options.map((option, index) => {
                        return <p className="faceted-filter__range-slider-text" key={"range-slider-text-" + option.id}>{index % 2 ? "" : option.label}</p>
                    })}
                </div>
            </div>
        </li>
    )
}

export default FacetedSearchSlider;
